import { joiResolver } from "@hookform/resolvers/joi";
import { Box, Link } from "@mui/material";
import React from "react";
import { useForm as useFormController } from "react-hook-form";

import { helperValidationSchemas, validationOptions } from "@bujus/common";

import { CsvFileUpload, Form } from "@/base";
import { config } from "@/config";

const HelpersImportDialog__FileUploadStepContent = ({ defaultFormData, onNext }) => {
    const formController = useFormController({
        mode: "onChange",
        resolver: joiResolver(helperValidationSchemas.import.forms.fileUpload, validationOptions),
        defaultValues: defaultFormData,
    });

    const handleCsvFileUploadChange = () => {
        formController.handleSubmit(onNext)();
    };

    return (
        <Form controller={formController}>
            <Link href={config.urls.importHelpers.helpers} target="_blank">
                Importhilfe herunterladen
            </Link>
            <Box mt={2}>
                <CsvFileUpload
                    fieldName="fileDatas"
                    label="CSV-Datei"
                    onChange={handleCsvFileUploadChange}
                />
            </Box>
        </Form>
    );
};

export { HelpersImportDialog__FileUploadStepContent };
